import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { observer } from 'mobx-react'
import { useAppState } from '../hooks/use-mobile-service'
import { AbilityAction } from '../../enums/ability-action.enum'
import { SubjectEntity } from '../../enums/ability-entity.enum'

interface ProtectedRouteProps {
    path: string
    component?: React.ComponentType<any>
    render?: () => React.ReactNode
    action: AbilityAction
    subject: SubjectEntity
}

/**
 * Route guard that checks CASL permissions before rendering.
 * If the user lacks the required ability, redirects to the domain dashboard.
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = observer(
    ({ path, component: Component, render: renderFn, action, subject }) => {
        const appState = useAppState()

        return (
            <Route
                path={path}
                render={(routeProps) => {
                    const allowed = appState.abilityStore.can(
                        action,
                        appState.abilityStore.getDomainOwnedIdentityFor(subject),
                    )

                    if (!allowed) {
                        const domainId = appState.currentDomain?.id
                        return <Redirect to={domainId ? `/domains/${domainId}/dashboard` : '/'} />
                    }

                    if (renderFn) return <>{renderFn()}</>
                    if (Component) return <Component {...routeProps} />
                    return null
                }}
            />
        )
    },
)
